<template>
  <div>
    <yxt-switch
      v-model="getValue"
      :active-value="1"
      :inactive-value="0"
      v-bind="$attrs.attrs"
      v-on="$attrs.on"
    ></yxt-switch>

    <span class="tlive-create__tip">
      &nbsp;
      {{
        $t(
          'pc_biz_externalConnectionWatchLive' /* 企业外部人员获得单独连接，通过微信授权观看 */
        )
      }}
    </span>
  </div>
</template>
<script>
export default {
  name: 'LiveOutside',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  computed: {
    getValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  data() {
    return {};
  }
};
</script>
<style scoped lang="less"></style>
